module.exports = __webpack_public_path__ + "img/edit-grey.3189f0cc.svg";